import { createAsyncThunk } from "@reduxjs/toolkit";
import { appName, chargebeeUrl } from "../../constants/defaultValues"

import axiosProvisioningCognito from "../utils/marquetCognito";

import {
  cognitoUri
} from "../../constants/defaultValues";

import {
  notification
} from "../actions";

export const preAuthentication = createAsyncThunk("preAuthentication", async (payload, thunkAPI) => {
  try {
    const response = await axiosProvisioningCognito.post(`${cognitoUri}/pre-authentication`, payload);
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(forgotPassword({username:response.data.data.userId}))
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `Authenticate user`, message: `${response.data.message}`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const forgotPassword = createAsyncThunk("forgotPassword", async (payload, thunkAPI) => {
  try {
    const response = await axiosProvisioningCognito.post(`${cognitoUri}/forgot-password`, payload);
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(notification({ title: `Authenticate user`, message: `${response.data.message}`, type: `success` }));
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `Authenticate user`, message: `${response.data.message}`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})